import React from 'react';
import { FaAngleRight } from 'react-icons/fa6';

import Button, { ButtonAppearance } from '../../../../../ui/Atoms/Button';
import Icon, { IconSize } from '../../../../../ui/Atoms/Icon';
import CollapseMenu from '../../../../../ui/Molecules/CollapseMenu';

import { getIcon } from '../../../../utils/getIcon';

import * as S from './BlogNavigationMobile.styles';

export const BlogNavigationMobile = ({ blogDropdowns }) => {
  const destructDropdown = ({ link, column }) => {
    const {
      [`dropdown_${column}_link_name`]: name,
      [`dropdown_${column}_description`]: description,
      [`dropdown_${column}_icon`]: icon,
      [`dropdown_${column}_link_color`]: color,
      [`dropdown_${column}_link_url`]: { id, target, url } = {},
    } = link || '';
    return { name, description, icon, color, url, id, target };
  };

  return (
    <>
      {blogDropdowns.map(
        ({ column, label, content, optionalLabel, optionalUrl }, index) => {
          if (!label || content.length === 0) return null;

          const { url: optionalLink, target: optionalTarget } =
            optionalUrl || '';
          const hasOptionalNav = !!optionalLabel && !!optionalLink;

          return (
            <CollapseMenu key={`blog-${index}`} title={label}>
              <S.MobileBlogMenuWrapper>
                {content.map((link, index) => {
                  const object = destructDropdown({ link, column });

                  if (!object?.name || !object?.url) {
                    return null;
                  }

                  return (
                    <S.HeaderLink
                      href={object?.url}
                      target={object?.target}
                      alt={object?.name}
                      key={`${link}-${index}`}
                    >
                      {object?.icon && (
                        <Icon customColor={object?.color} size={IconSize.MICRO}>
                          {getIcon(object?.icon)}
                        </Icon>
                      )}
                      <S.LinkWrapper>
                        {object?.name && (
                          <S.LinkLabel>{object?.name}</S.LinkLabel>
                        )}
                        {object?.description && (
                          <S.LinkDescription>
                            {object?.description}
                          </S.LinkDescription>
                        )}
                      </S.LinkWrapper>
                    </S.HeaderLink>
                  );
                })}
                {hasOptionalNav && (
                  <S.OptionalButtonWrapper>
                    <Button
                      appearance={ButtonAppearance.MINIMAL}
                      link={optionalLink}
                      target={optionalTarget}
                    >
                      {optionalLabel}
                      <FaAngleRight />
                    </Button>
                  </S.OptionalButtonWrapper>
                )}
              </S.MobileBlogMenuWrapper>
            </CollapseMenu>
          );
        }
      )}
    </>
  );
};
